import { render, staticRenderFns } from "./saleStar.vue?vue&type=template&id=10b1ac4c&scoped=true&"
import script from "./saleStar.vue?vue&type=script&lang=js&"
export * from "./saleStar.vue?vue&type=script&lang=js&"
import style0 from "./saleStar.vue?vue&type=style&index=0&id=10b1ac4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b1ac4c",
  null
  
)

export default component.exports